<template>
  <div>
    <van-nav-bar :border="false" :fixed="true">
      <template #title>
        <div class="switch">

          <div @click="goNF" :class="$store.state.newsFlashTitle===0?'nFButtonOn':'nFButton'"><span
              :class="$store.state.newsFlashTitle===0?'nFTextOn':'nFText'">快讯</span></div>
          <div @click="goCal" :class="$store.state.newsFlashTitle===1?'calButtonOn':'calButton'"><span
              :class="$store.state.newsFlashTitle===1?'calTextOn':'calText'">日历</span></div>

        </div>
      </template>
      <template #right>
        <div @click="$store.state.calShow = true" v-if="$store.state.newsFlashTitle===1">
        <svg-icon icon-class="calendar" style="width:19px;height:18px;"></svg-icon>
        </div>
      </template>
    </van-nav-bar>

    <router-view></router-view>

  </div>
</template>

<script>
import newsFlashList from "@/components/newsFlash/newsFlashList";
import calendar from "@/components/newsFlash/calendar";
export default {
  name: "newsFlashTitle",
  components: {newsFlashList, calendar},
  data() {
    return {
    }
  },
  methods: {
    goNF() {
      if (this.$route.path !== '/newsFlash/newsFlash') {
        this.$router.push('/newsFlash/newsFlash');
        this.$store.state.newsFlashTitle = 0;
      }
    },
    goCal() {
      if (this.$route.path !== '/newsFlash/calendar') {
        this.$router.push('/newsFlash/calendar');
        this.$store.state.newsFlashTitle = 1;
      }
    },
    checkUrl(){
      if (this.$store.state.newsFlashTitle===0) {
        this.$router.push('/newsFlash/newsFlash');
      } else if (this.$store.state.newsFlashTitle===1) {
        this.$router.push('/newsFlash/calendar');
      }
    }
  },
  created() {
    this.checkUrl()
  }
}
</script>

<style scoped>
.switch {
  display: flex;
  width: 112px;
}

.nFButton {
  width: 55px;
  height: 28px;
  color: #93a2b8;
  border: 1px solid;
  border-right: 0;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.nFButtonOn {
  width: 55px;
  height: 28px;
  color: #1875f8;
  background-color: #1875f8;
  border: 1px solid;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.calButton {
  width: 55px;
  height: 28px;
  color: #93a2b8;
  border: 1px solid;
  border-left: 0;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;

}

.calButtonOn {
  width: 55px;
  height: 28px;
  color: #1875f8;
  background-color: #1875f8;
  border: 1px solid;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;


}


.nFText {
  line-height: 30px;
}

.nFTextOn {
  line-height: 30px;
  color: white;
  font-weight: bolder;
}

.calText {
  line-height: 30px;
}

.calTextOn {
  line-height: 30px;
  color: white;
  font-weight: bolder;
}


</style>
